import { createContext, useContext } from 'react';
import { FileImporterProviderProps } from './types';

export const FileImporterContext = createContext<FileImporterProviderProps>({} as FileImporterProviderProps);

/**
 * @deprecated FileImporter is deprecated and no longer functions. Use the DataGrid component instead.
 */
export const useFileImporterContext = (): FileImporterProviderProps => useContext(FileImporterContext);
